import { render, staticRenderFns } from "./UserText.vue?vue&type=template&id=4bd471f6&"
import script from "./UserText.vue?vue&type=script&lang=js&"
export * from "./UserText.vue?vue&type=script&lang=js&"
import style0 from "./UserText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports